[
  ["NEI","","No evidence for inducible myocardial ischemia"],
  ["NEE","","No evidence for inducible echocardiographic signs of ischemia"],
  ["NCS","","Non-conclusive stress echo study (HR target not achieved)"],
  ["EIM","","Evidence for inducible myocardial ischemia"],
  ["TIL","","Transient ischemic LV dilatation"],
  ["NCP","","Non-conclusive stress echo study, poor imaging quality T/D"],
  ["AA","","Apical akinesis"],
  ["AR","","Aortic regurgitation"],
  ["AR","MIN","Aortic regurgitation, minimal"],
  ["AR","MIL","Aortic regurgitation, mild"],
  ["AR","MM","Aortic regurgitation, mild to moderate"],
  ["AR","MOD","Aortic regurgitation, moderate"],
  ["AR","MS","Aortic regurgitation, moderate to severe"],
  ["AR","SEV","Aortic regurgitation, severe"],
  ["AS","","Aortic stenosis"],
  ["AS","MIN","Aortic stenosis, minimal"],
  ["AS","MIL","Aortic stenosis, mild"],
  ["AS","MM","Aortic stenosis, mild to moderate"],
  ["AS","MOD","Aortic stenosis, moderate"],
  ["AS","MS","Aortic stenosis, moderate to severe"],
  ["AS","SEV","Aortic stenosis, severe"],
  ["ASD","","Atrial septal defect"],
  ["AT","","Apical thrombus"],
  ["AVR","","Status post AVR"],
  ["BAV","","Bicuspid aortic valve"],
  ["BEP","","Borderline elevated pulmonary pressure"],
  ["BRA","","Bradycardia"],
  ["CAA","","Calcified aortic valve and mitral annulus"],
  ["CAA","MIN","Calcified aortic valve and mitral annulus, minimal"],
  ["CAA","MIL","Calcified aortic valve and mitral annulus, mild"],
  ["CAA","MM","Calcified aortic valve and mitral annulus, mild to moderate"],
  ["CAA","MOD","Calcified aortic valve and mitral annulus, moderate"],
  ["CAA","MS","Calcified aortic valve and mitral annulus, moderate to severe"],
  ["CAA","SEV","Calcified aortic valve and mitral annulus, severe"],
  ["CAV","","Calcified aortic valve"],
  ["CAV","MIN","Calcified aortic valve, minimal"],
  ["CAV","MIL","Calcified aortic valve, mild"],
  ["CAV","MM","Calcified aortic valve, mild to moderate"],
  ["CAV","MOD","Calcified aortic valve, moderate"],
  ["CAV","MS","Calcified aortic valve, moderate to severe"],
  ["CAV","SEV","Calcified aortic valve, severe"],
  ["CLV","","Calculated LVEF"],
  ["CMA","","Calcified mitral annulus"],
  ["CMA","MIN","Calcified mitral annulus, minimal"],
  ["CMA","MIL","Calcified mitral annulus, mild"],
  ["CMA","MM","Calcified mitral annulus, mild to moderate"],
  ["CMA","MOD","Calcified mitral annulus, moderate"],
  ["CMA","MS","Calcified mitral annulus, moderate to severe"],
  ["CMA","SEV","Calcified mitral annulus, severe"],
  ["CMA","SIG","Calcified mitral annulus, with significant inflow restriction"],
  ["DA","","Dilated atria"],
  ["DA","MIN","Dilated atria, minimal"],
  ["DA","MIL","Dilated atria, mild"],
  ["DA","MM","Dilated atria, mild to moderate"],
  ["DA","MOD","Dilated atria, moderate"],
  ["DA","MS","Dilated atria, moderate to severe"],
  ["DA","SEV","Dilated atria, severe"],
  ["DAA","","Dilated ascending aorta"],
  ["DAA","MIN","Dilated ascending aorta, minimal"],
  ["DAA","MIL","Dilated ascending aorta, mild"],
  ["DAA","MM","Dilated ascending aorta, mild to moderate"],
  ["DAA","MOD","Dilated ascending aorta, moderate"],
  ["DAA","MS","Dilated ascending aorta, moderate to severe"],
  ["DAA","SEV","Dilated ascending aorta, severe"],
  ["DHR","","Dilated hypokinetic right ventricle"],
  ["DLA","","Dilated left atrium"],
  ["DLV","","Dilated left ventricle"],
  ["DLV","MIN","Dilated left ventricle, minimal"],
  ["DLV","MIL","Dilated left ventricle, mild"],
  ["DLV","MM","Dilated left ventricle, mild to moderate"],
  ["DLV","MOD","Dilated left ventricle, moderate"],
  ["DLV","MS","Dilated left ventricle, moderate to severe"],
  ["DLV","SEV","Dilated left ventricle, severe"],
  ["DRV","","Dilated right ventricle"],
  ["DRV","MIN","Dilated right ventricle, minimal"],
  ["DRV","MIL","Dilated right ventricle, mild"],
  ["DRV","MM","Dilated right ventricle, mild to moderate"],
  ["DRV","MOD","Dilated right ventricle, moderate"],
  ["DRV","MS","Dilated right ventricle, moderate to severe"],
  ["DRV","SEV","Dilated right ventricle, severe"],
  ["DRP","","Dilated right ventricle with preserved function"],
  ["DRP","MIN","Dilated right ventricle with preserved function, minimal"],
  ["DRP","MIL","Dilated right ventricle with preserved function, mild"],
  ["DRP","MM","Dilated right ventricle with preserved function, mild to moderate"],
  ["DRP","MOD","Dilated right ventricle with preserved function, moderate"],
  ["DRP","MS","Dilated right ventricle with preserved function, moderate to severe"],
  ["DRP","SEV","Dilated right ventricle with preserved function, severe"],
  ["DLW","","Dilated left ventricle with global hypokinesis"],
  ["DLW","MIN","Dilated left ventricle with global hypokinesis, minimal"],
  ["DLW","MIL","Dilated left ventricle with global hypokinesis, mild"],
  ["DLW","MM","Dilated left ventricle with global hypokinesis, mild to moderate"],
  ["DLW","MOD","Dilated left ventricle with global hypokinesis, moderate"],
  ["DLW","MS","Dilated left ventricle with global hypokinesis, moderate to severe"],
  ["DLW","SEV","Dilated left ventricle with global hypokinesis, severe"],
  ["EFP","","Elevated left ventricular filling pressure"],
  ["EFP","MIN","Elevated left ventricular filling pressure, minimal"],
  ["EFP","MIL","Elevated left ventricular filling pressure, mild"],
  ["EFP","MM","Elevated left ventricular filling pressure, mild to moderate"],
  ["EFP","MOD","Elevated left ventricular filling pressure, moderate"],
  ["EFP","MS","Elevated left ventricular filling pressure, moderate to severe"],
  ["EFP","SEV","Elevated left ventricular filling pressure, severe"],
  ["ELA","","Enlarged left atrium"],
  ["ELA","MIN","Enlarged left atrium, minimal"],
  ["ELA","MIL","Enlarged left atrium, mild"],
  ["ELA","MM","Enlarged left atrium, mild to moderate"],
  ["ELA","MOD","Enlarged left atrium, moderate"],
  ["ELA","MS","Enlarged left atrium, moderate to severe"],
  ["ELA","SEV","Enlarged left atrium, severe"],
  ["ELV","","Enlarged left ventricle"],
  ["ELV","MIN","Enlarged left ventricle, minimal"],
  ["ELV","MIL","Enlarged left ventricle, mild"],
  ["ELV","MM","Enlarged left ventricle, mild to moderate"],
  ["ELV","MOD","Enlarged left ventricle, moderate"],
  ["ELV","MS","Enlarged left ventricle, moderate to severe"],
  ["ELV","SEV","Enlarged left ventricle, severe"],
  ["ELVE","","Estimated LVEF"],
  ["ERA","","Enlarged right atrium"],
  ["ERA","MIN","Enlarged right atrium, minimal"],
  ["ERA","MIL","Enlarged right atrium, mild"],
  ["ERA","MM","Enlarged right atrium, mild to moderate"],
  ["ERA","MOD","Enlarged right atrium, moderate"],
  ["ERA","MS","Enlarged right atrium, moderate to severe"],
  ["ERA","SEV","Enlarged right atrium, severe"],
  ["ERV","","Enlarged right ventricle"],
  ["F","","Fever"],
  ["FL","","Flail mitral leaflet"],
  ["GH","","Global hypokinesis"],
  ["GHR","","Generalized LV hypo-akinesis with regional variation"],
  ["HLV","","Hyperdynamic left ventricle"],
  ["HLV","MIN","Hyperdynamic left ventricle, minimal"],
  ["HLV","MIL","Hyperdynamic left ventricle, mild"],
  ["HLV","MM","Hyperdynamic left ventricle, mild to moderate"],
  ["HLV","MOD","Hyperdynamic left ventricle, moderate"],
  ["HLV","MS","Hyperdynamic left ventricle, moderate to severe"],
  ["HLV","SEV","Hyperdynamic left ventricle, severe"],
  ["HOCM","","Hypertrophic cardiomyopathy"],
  ["HRV","","Hypokinetic right ventricle"],
  ["HRV","MIN","Hypokinetic right ventricle, minimal"],
  ["HRV","MIL","Hypokinetic right ventricle, mild"],
  ["HRV","MM","Hypokinetic right ventricle, mild to moderate"],
  ["HRV","MOD","Hypokinetic right ventricle, moderate"],
  ["HRV","MS","Hypokinetic right ventricle, moderate to severe"],
  ["HRV","SEV","Hypokinetic right ventricle, severe"],
  ["IMLC","","Incomplete mitral leaflet closure"],
  ["IR","","Impaired left ventricular relaxation pattern"],
  ["IR","MIN","Impaired left ventricular relaxation pattern, minimal"],
  ["IR","MIL","Impaired left ventricular relaxation pattern, mild"],
  ["IR","MM","Impaired left ventricular relaxation pattern, mild to moderate"],
  ["IR","MOD","Impaired left ventricular relaxation pattern, moderate"],
  ["IR","MS","Impaired left ventricular relaxation pattern, moderate to severe"],
  ["IR","SEV","Impaired left ventricular relaxation pattern, severe"],
  ["LVA","","Left ventricular aneurysm"],
  ["LVD","","Left ventricular dysfunction"],
  ["LVD","MIN","Left ventricular dysfunction, minimal"],
  ["LVD","MIL","Left ventricular dysfunction, mild"],
  ["LVD","MM","Left ventricular dysfunction, mild to moderate"],
  ["LVD","MOD","Left ventricular dysfunction, moderate"],
  ["LVD","MS","Left ventricular dysfunction, moderate to severe"],
  ["LVD","SEV","Left ventricular dysfunction, severe"],
  ["LVF","","Left ventricular function"],
  ["LVH","","Left ventricular hypertrophy"],
  ["LVH","MIN","Left ventricular hypertrophy, minimal"],
  ["LVH","MIL","Left ventricular hypertrophy, mild"],
  ["LVH","MM","Left ventricular hypertrophy, mild to moderate"],
  ["LVH","MOD","Left ventricular hypertrophy, moderate"],
  ["LVH","MS","Left ventricular hypertrophy, moderate to severe"],
  ["LVH","SEV","Left ventricular hypertrophy, severe"],
  ["LVW","","Left ventricular wall motion abnormalities"],
  ["MR","","Mitral regurgitation"],
  ["MR","MIN","Mitral regurgitation, minimal"],
  ["MR","MIL","Mitral regurgitation, mild"],
  ["MR","MM","Mitral regurgitation, mild to moderate"],
  ["MR","MOD","Mitral regurgitation, moderate"],
  ["MR","MS","Mitral regurgitation, moderate to severe"],
  ["MR","SEV","Mitral regurgitation, severe"],
  ["MS","","Mitral stenosis"],
  ["MVG","","Mid-ventricular dynamic gradient"],
  ["MVP","","Mitral valve prolapse"],
  ["MVR","","Status post MVR"],
  ["N","","Normal right and left ventricular size and function"],
  ["NAF","","New atrial fibrillation"],
  ["NED","","Normal Doppler-echo study"],
  ["NLV","","Normal left ventricular size and function"],
  ["NLW","","Non-dilated left ventricle with global hypokinesis"],
  ["NLW","MIN","Non-dilated left ventricle with global hypokinesis, minimal"],
  ["NLW","MIL","Non-dilated left ventricle with global hypokinesis, mild"],
  ["NLW","MM","Non-dilated left ventricle with global hypokinesis, mild to moderate"],
  ["NLW","MOD","Non-dilated left ventricle with global hypokinesis, moderate"],
  ["NLW","MS","Non-dilated left ventricle with global hypokinesis, moderate to severe"],
  ["NLW","SEV","Non-dilated left ventricle with global hypokinesis, severe"],
  ["NPH","","No pulmonary hypertension detected"],
  ["NPV","","Normal prosthetic valve function"],
  ["NRV","","Normal right ventricular size and function"],
  ["NST","","Status post NSTEMI"],
  ["PC","","Pulmonary congestion"],
  ["PDA","","Patent ductus arteriosus"],
  ["PED","","Status post pulmonary edema"],
  ["PEF","","Pericardial effusion"],
  ["PEF","MIN","Pericardial effusion, minimal"],
  ["PEF","SM","Pericardial effusion, small"],
  ["PEF","STM","Pericardial effusion, small to moderate"],
  ["PEF","MOD","Pericardial effusion, moderate"],
  ["PEF","ML","Pericardial effusion, moderate to large"],
  ["PEF","LA","Pericardial effusion, large"],
  ["PEV","","Prominent Eustachian valve"],
  ["PFO","","Patent foramen ovale"],
  ["PHT","","Pulmonary hypertension"],
  ["PHT","B","Pulmonary hypertension, borderline"],
  ["PHT","MIN","Pulmonary hypertension, minimal"],
  ["PHT","MIL","Pulmonary hypertension, mild"],
  ["PHT","MM","Pulmonary hypertension, mild to moderate"],
  ["PHT","MOD","Pulmonary hypertension, moderate"],
  ["PHT","MS","Pulmonary hypertension, moderate to severe"],
  ["PHT","SEV","Pulmonary hypertension, severe"],
  ["PGL","","Preserved global left ventricular function"],
  ["PIQ","","Poor imaging quality"],
  ["PR","","Pulmonic regurgitation"],
  ["PRE","","Partial repeat examination"],
  ["PRV","","Preserved right ventricular function"],
  ["PS","","Pulmonic stenosis"],
  ["RA","","Rheumatoid arthritis"],
  ["RMV","","Rheumatic mitral valve changes"],
  ["RF","","Restrictive LV filling pattern"],
  ["RF","MIN","Restrictive LV filling pattern, minimal"],
  ["RF","MIL","Restrictive LV filling pattern, mild"],
  ["RF","MM","Restrictive LV filling pattern, mild to moderate"],
  ["RF","MOD","Restrictive LV filling pattern, moderate"],
  ["RF","MS","Restrictive LV filling pattern, moderate to severe"],
  ["RF","SEV","Restrictive LV filling pattern, severe"],
  ["RMI","","Status post recent MI"],
  ["RVF","","Right ventricular function"],
  ["RVSD","","Restrictive ventricular septal defect"],
  ["SAM","","Systolic anterior motion of the mitral valve"],
  ["SDG","","Small dynamic intraventricular LV gradient"],
  ["SH","","Septal hypertrophy"],
  ["SH","MIN","Septal hypertrophy, minimal"],
  ["SH","MIL","Septal hypertrophy, mild"],
  ["SH","MM","Septal hypertrophy, mild to moderate"],
  ["SH","MOD","Septal hypertrophy, moderate"],
  ["SH","MS","Septal hypertrophy, moderate to severe"],
  ["SH","SEV","Septal hypertrophy, severe"],
  ["SLE","","Systemic lupus erythematosus"],
  ["SOE","","Source of emboli"],
  ["SV","","Segmental variation"],
  ["SWM","","Segmental wall motion abnormality"],
  ["TAM","","Tamponade, O/H"],
  ["TDE","","Technically difficult echo"],
  ["TMLS","","Thickened mitral leaflets"],
  ["TR","","Tricuspid regurgitation"],
  ["TR","MIN","Tricuspid regurgitation, minimal"],
  ["TR","MIL","Tricuspid regurgitation, mild"],
  ["TR","MM","Tricuspid regurgitation, mild to moderate"],
  ["TR","MOD","Tricuspid regurgitation, moderate"],
  ["TR","MS","Tricuspid regurgitation, moderate to severe"],
  ["TR","SEV","Tricuspid regurgitation, severe"],
  ["USH","","Upper septal hypertrophy"],
  ["V","","Normal valvular structure and function"],
  ["VER","","Vertigo"],
  ["VSD","","Ventricular septal defect"],
  ["WMA","","Wall motion abnormality"],
  ["WMA","MIN","Wall motion abnormality, minimal"],
  ["WMA","MIL","Wall motion abnormality, mild"],
  ["WMA","MM","Wall motion abnormality, mild to moderate"],
  ["WMA","MOD","Wall motion abnormality, moderate"],
  ["WMA","MS","Wall motion abnormality, moderate to severe"],
  ["WMA","SEV","Wall motion abnormality, severe"]
]
